import { checkAndBustCache } from './lib/version'
// Run cache check before anything else renders
checkAndBustCache()

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './App.css'
import App from './App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)